/* ============================================
   BRAVIK — Motion Layer (GSAP ScrollTrigger)
   Adapted for custom theme class names
   ============================================ */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
    gsap.registerPlugin(ScrollTrigger);

    if (reduceMotion) return;

    /* ---- Hero: cinematic entrance ---- */
    var heroHeadline = document.querySelector('.hero-headline');
    if (heroHeadline) {
      var tl = gsap.timeline({ defaults: { ease: 'power3.out' } });
      tl.from('.hero-headline', { y: 44, opacity: 0, duration: 1.05 })
        .from('.hero-subheadline', { y: 26, opacity: 0, duration: 0.85 }, '-=0.6')
        .from('.hero-cta-group', { y: 20, opacity: 0, duration: 0.75 }, '-=0.5');

      var heroBg = document.querySelector('.hero-section img, .hero-bg img, .hero-media img');
      if (heroBg) {
        gsap.to(heroBg, {
          yPercent: 10,
          ease: 'none',
          scrollTrigger: { trigger: '.hero-section', start: 'top top', end: 'bottom top', scrub: true }
        });
      }
    }

    /* ---- Section headers: fade-up ---- */
    gsap.utils.toArray('.section-header').forEach(function (el) {
      gsap.fromTo(el, { y: 34, opacity: 0 },
        { y: 0, opacity: 1, duration: 0.85, ease: 'power3.out',
          scrollTrigger: { trigger: el, start: 'top 86%', once: true } });
    });

    /* ---- Category cards: stagger ---- */
    ScrollTrigger.batch('.category-card', {
      start: 'top 90%', once: true,
      onEnter: function (batch) {
        gsap.fromTo(batch, { y: 42, opacity: 0 },
          { y: 0, opacity: 1, duration: 0.8, ease: 'power3.out', stagger: 0.1, overwrite: true });
      }
    });

    /* ---- Product cards: stagger ---- */
    ScrollTrigger.batch('.product-card', {
      start: 'top 90%', once: true,
      onEnter: function (batch) {
        gsap.fromTo(batch, { y: 44, opacity: 0 },
          { y: 0, opacity: 1, duration: 0.8, ease: 'power3.out', stagger: 0.1, overwrite: true });
      }
    });

    /* ---- Why Bravik cards: stagger ---- */
    ScrollTrigger.batch('.why-bravik-card', {
      start: 'top 88%', once: true,
      onEnter: function (batch) {
        gsap.fromTo(batch, { y: 36, opacity: 0 },
          { y: 0, opacity: 1, duration: 0.75, ease: 'power3.out', stagger: 0.14, overwrite: true });
      }
    });

    /* ---- Social proof grid: stagger ---- */
    ScrollTrigger.batch('.social-proof-item', {
      start: 'top 90%', once: true,
      onEnter: function (batch) {
        gsap.fromTo(batch, { scale: 0.94, opacity: 0 },
          { scale: 1, opacity: 1, duration: 0.7, ease: 'power2.out', stagger: 0.08, overwrite: true });
      }
    });

    /* ---- Lifestyle banner: parallax ---- */
    var lbBg = document.querySelector('.lifestyle-banner-bg img');
    if (lbBg) {
      gsap.to(lbBg, {
        yPercent: 12,
        ease: 'none',
        scrollTrigger: { trigger: '.lifestyle-banner', start: 'top bottom', end: 'bottom top', scrub: true }
      });
      gsap.fromTo('.lifestyle-banner-content', { y: 40, opacity: 0 },
        { y: 0, opacity: 1, duration: 0.9, ease: 'power3.out',
          scrollTrigger: { trigger: '.lifestyle-banner', start: 'top 70%', once: true } });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
